<template>
  <div class="extensionLog-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入用户ID" size="small" clearable @keyup.enter.native="getExtensionList('status')" class="param-input" v-model="params.uid"></el-input>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
       <el-button type="primary" size="small" @click="getExtensionList()" class="search">搜索</el-button>
    </div>
    <!--表格数据-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="id" label="ID" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.id || '暂无说明'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.uid || '暂无说明'}}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="promotionCode" label="用户推广码" align="center"></el-table-column>
      -->
      <el-table-column prop="invitee" label="下级ID" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.invitee || '暂无说明'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import API from '@/api'
import { changeTime } from '@/utils/global'
export default {
  data() {
    return {
      loading: false,
      total: 0,
      tableData: [],
      time: '',
      params: {
        pageNumber: 1,
        pageSize: 10,
        uid: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  created() {
    this.getExtensionList()
  },
  methods: {
    // 请求推广列表
    getExtensionList(type) {
      if(type === 'status') {
        this.params.pageNumber = 1
      }
      this.loading = true
      API.getExtensionList(this.params).then(res => {
        if (res.code === 200 && res.data.history) {
          this.tableData = res.data.history
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.tableData = []
        this.total = 0
      })
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || ''
        this.params.endTime = changeTime(time[1]) || ''
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.getExtensionList('status')
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getExtensionList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getExtensionList()
    },
  }
}
</script>

